import React, { useContext } from 'react'
import { toast } from 'react-toastify'

import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader
} from '@clientbase/clientbase-library'
import { Avatar, Box, Grid, Stack, Typography } from '@mui/material'
import copy from 'copy-to-clipboard'

import IconContainer from 'components/IconContainer/IconContainer'

import { formatPhone } from 'utils'

import { NegativationContext } from '../../../context'
import { S } from './'

export const ContactDialog: React.FC = () => {
  const { dialogContact, updateDialogContact, updateModalDetail } =
    useContext(NegativationContext)

  const closeDialog = () => {
    // `external` = aberto pelo menu da tabela, sem detalhe por baixo. Só
    // restaura o modal de detalhes quando o diálogo saiu de dentro dele.
    if (!dialogContact?.external) {
      updateModalDetail((prevState) => ({ ...prevState, open: true }))
    }
    updateDialogContact({
      open: false,
      email: undefined,
      phone: undefined,
      external: undefined
    })
  }

  const handleCopy = (label: string, value: string) => {
    toast.success(`${label} copiado com sucesso.`)
    copy(value)
  }

  function stringAvatar(name: string) {
    const regex = name.match(/[a-zA-Z]+/g) as RegExpMatchArray
    const filtred = regex?.length > 0 ? regex[0] : ''
    return {
      children: `${filtred.split(' ')[0][0].toUpperCase()}`
    }
  }

  return (
    <Modal
      open={dialogContact?.open || false}
      handleClose={closeDialog}
      width="500px"
      height="auto"
    >
      <ModalBody>
        <ModalHeader onClose={closeDialog}>
          <Stack direction="row" alignItems="center" gap={2}>
            <IconContainer icon="accountCircle" />
            <Typography variant="mdBold">Detalhes do cliente</Typography>
          </Stack>
        </ModalHeader>

        <ModalContent>
          <Stack>
            <S.ContactName>
              <Avatar
                sx={{ width: '32px', height: '32px' }}
                {...stringAvatar((dialogContact?.name as string) || 'A')}
              />
              <Box display="flex" flexDirection="column">
                <Typography variant="xsLight" color="#757675">
                  Nome completo:
                </Typography>
                <Typography variant="xsBold">{dialogContact?.name}</Typography>
              </Box>
            </S.ContactName>

            <Grid container={true} spacing={2} mt={0}>
              <Grid item={true} md={6} xs={12}>
                <S.ContactPhoneAndNumber>
                  <Typography variant="xsLight" color="#757675">
                    Telefone:
                  </Typography>
                  <Typography variant="xsBold">
                    {formatPhone(dialogContact?.phone || '')}
                  </Typography>
                </S.ContactPhoneAndNumber>
              </Grid>
              <Grid item={true} md={6} xs={12}>
                <S.ContactPhoneAndNumber>
                  <Typography variant="xsLight" color="#757675">
                    E-mail:
                  </Typography>
                  <Typography variant="xsBold">
                    {dialogContact?.email}
                  </Typography>
                </S.ContactPhoneAndNumber>
              </Grid>
            </Grid>
          </Stack>
        </ModalContent>

        <ModalFooter>
          <Button
            variantButton="primary"
            disabled={!dialogContact?.phone}
            onClick={() =>
              handleCopy('Telefone', formatPhone(dialogContact?.phone || ''))
            }
          >
            Telefone
          </Button>

          <Button
            disabled={!dialogContact?.email}
            onClick={() => handleCopy('E-mail', dialogContact?.email || '')}
          >
            E-mail
          </Button>
        </ModalFooter>
      </ModalBody>
    </Modal>
  )
}
